import React from "react"
import { formatDateRange } from "@love-irish/resource-calendar-date-range"
import { ResultRowShell } from "./result_row_shell"
import { CategoryIcon } from "../category_icon"
import type { SearchRowComponent } from "./types"
import Title from "@love-irish/core-title"

// A calendar-event collection result: a calendar glyph, the event name, and a compact date range on the
// right (when the event has one) so festivals/events read differently from plain collections.
export const CalendarEventRow: SearchRowComponent = ({
  hit,
  position,
  onSelect,
}) => {
  const dateLabel = hit.startsAt
    ? formatDateRange(new Date(hit.startsAt), hit.endsAt ? new Date(hit.endsAt) : null, {
        shortFormat: true,
      })
    : ""

  return (
    <ResultRowShell hit={hit} position={position} onSelect={onSelect}>
      <CategoryIcon category="Events" className="shrink-0 text-secondary-400" />
      <Title
        size="xs"
        className="truncate font-sans! text-sm"
        variant="plain"
        title={hit.name}
      />
      {dateLabel && (
        <span className="ml-auto shrink-0 text-xs text-secondary-400">
          {dateLabel}
        </span>
      )}
    </ResultRowShell>
  )
}
